// Iniciály pro fallback avataru (když uživatel nemá profilovou fotku).
// Z "Jméno Příjmení" udělá dvě velká písmena, z jednoho slova první dvě.
export default function getProfileInitials(value) {
	const parts = (value || '')
		.replace(/[^\p{L}\p{N}\s]/gu, ' ')
		.split(/\s+/)
		.filter(Boolean);

	if (parts.length >= 2) {
		return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
	}

	if (parts.length === 1) {
		return parts[0].substring(0, 2).toUpperCase();
	}

	return '';
}
